import React, { useEffect, useRef, useState } from 'react';
import { Logo } from './Logo';
import { resetPassword } from '../api/auth.js';

export function ResetPasswordView() {
    const link = useRef(new URLSearchParams(window.location.hash.slice(1))).current;
    const tokenHash = link.get('type') === 'recovery' ? link.get('token_hash') || '' : '';
    const [password, setPassword] = useState('');
    const [repeat, setRepeat] = useState('');
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    useEffect(() => {
        window.history.replaceState(null, '', '/reset-password');
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        if (password.length < 8) { setError('Минимум 8 символов'); return; }
        if (password !== repeat) { setError('Пароли не совпадают'); return; }
        setBusy(true);
        try {
            await resetPassword(tokenHash, password);
            setDone(true);
        } catch (err) {
            setError(err?.response?.data?.error || err?.message || 'Не удалось изменить пароль');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className='auth'>
            <form className='auth-card' onSubmit={handleSubmit}>
                <div className='auth-logo' style={{ display: 'flex', justifyContent: 'center' }}>
                    <Logo />
                </div>
                {done ? (
                    <>
                        <p className='auth-subtitle'>Пароль изменён</p>
                        <button className='auth-button' type='button' onClick={() => { window.location.href = '/'; }}>
                            Ко входу
                        </button>
                    </>
                ) : (
                    <>
                        <p className='auth-subtitle'>Новый пароль</p>
                        <label className='auth-label'>
                            Пароль
                            <input
                                className='auth-input'
                                type='password'
                                required
                                minLength={8}
                                value={password}
                                onChange={event => setPassword(event.target.value)}
                            />
                        </label>
                        <label className='auth-label'>
                            Повторите пароль
                            <input
                                className='auth-input'
                                type='password'
                                required
                                minLength={8}
                                value={repeat}
                                onChange={event => setRepeat(event.target.value)}
                            />
                        </label>
                        {error && <div className='auth-error'>{error}</div>}
                        <button className='auth-button' type='submit' disabled={busy}>
                            {busy ? 'Сохраняем…' : 'Сменить пароль'}
                        </button>
                    </>
                )}
            </form>
        </div>
    );
}
